/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SupportRouteImport } from './routes/support'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as PosteRouteImport } from './routes/poste'
import { Route as InviteRouteImport } from './routes/invite'
import { Route as ConfidentialiteRouteImport } from './routes/confidentialite'
import { Route as ConditionsRouteImport } from './routes/conditions'
import { Route as BorneRouteImport } from './routes/borne'
import { Route as DashboardRouteImport } from './routes/_dashboard'
import { Route as PosteIndexRouteImport } from './routes/poste/index'
import { Route as BorneIndexRouteImport } from './routes/borne/index'
import { Route as DashboardIndexRouteImport } from './routes/_dashboard/index'
import { Route as PosteColisRouteImport } from './routes/poste/colis'
import { Route as PosteCodeRouteImport } from './routes/poste/code'
import { Route as PosteBorneRouteImport } from './routes/poste/borne'
import { Route as PosteAujourdhuiRouteImport } from './routes/poste/aujourdhui'
import { Route as PosteAttendusRouteImport } from './routes/poste/attendus'
import { Route as PosteArriveesRouteImport } from './routes/poste/arrivees'
import { Route as PosteAppairageRouteImport } from './routes/poste/appairage'
import { Route as PosteAccesRouteImport } from './routes/poste/acces'
import { Route as PassTokenRouteImport } from './routes/pass.$token'
import { Route as BorneAppairageRouteImport } from './routes/borne/appairage'
import { Route as BTokenRouteImport } from './routes/b.$token'
import { Route as DashboardVisiteursRouteImport } from './routes/_dashboard/visiteurs'
import { Route as DashboardSurSiteRouteImport } from './routes/_dashboard/sur-site'
import { Route as DashboardRepertoireRouteImport } from './routes/_dashboard/repertoire'
import { Route as DashboardReglagesRouteImport } from './routes/_dashboard/reglages'
import { Route as DashboardRapportsRouteImport } from './routes/_dashboard/rapports'
import { Route as DashboardOrganizationsRouteImport } from './routes/_dashboard/organizations'
import { Route as DashboardJournalRouteImport } from './routes/_dashboard/journal'
import { Route as DashboardInvitationsRouteImport } from './routes/_dashboard/invitations'
import { Route as DashboardGestionReservationsRouteImport } from './routes/_dashboard/gestion-reservations'
import { Route as DashboardEquipeRouteImport } from './routes/_dashboard/equipe'
import { Route as DashboardColisRouteImport } from './routes/_dashboard/colis'
import { Route as DashboardAttendusRouteImport } from './routes/_dashboard/attendus'
import { Route as DashboardArriveesImprevuesRouteImport } from './routes/_dashboard/arrivees-imprevues'
import { Route as DashboardActiviteRouteImport } from './routes/_dashboard/activite'
import { Route as DashboardAccountsRouteImport } from './routes/_dashboard/accounts'
import { Route as DashboardReservationsIndexRouteImport } from './routes/_dashboard/reservations.index'
import { Route as DashboardReglagesIndexRouteImport } from './routes/_dashboard/reglages.index'
import { Route as DashboardInviterIndexRouteImport } from './routes/_dashboard/inviter.index'
import { Route as DashboardCompteIndexRouteImport } from './routes/_dashboard/compte.index'
import { Route as DashboardReservationsMesReservationsRouteImport } from './routes/_dashboard/reservations.mes-reservations'
import { Route as DashboardReservationsAmenityIdRouteImport } from './routes/_dashboard/reservations.$amenityId'
import { Route as DashboardReglagesValidationsRouteImport } from './routes/_dashboard/reglages.validations'
import { Route as DashboardReglagesUnitesRouteImport } from './routes/_dashboard/reglages.unites'
import { Route as DashboardReglagesReservationsRouteImport } from './routes/_dashboard/reglages.reservations'
import { Route as DashboardReglagesPortailsRouteImport } from './routes/_dashboard/reglages.portails'
import { Route as DashboardReglagesLegalRouteImport } from './routes/_dashboard/reglages.legal'
import { Route as DashboardReglagesInvitationsRouteImport } from './routes/_dashboard/reglages.invitations'
import { Route as DashboardReglagesGeneralRouteImport } from './routes/_dashboard/reglages.general'
import { Route as DashboardReglagesFormulairesRouteImport } from './routes/_dashboard/reglages.formulaires'
import { Route as DashboardReglagesDonneesRouteImport } from './routes/_dashboard/reglages.donnees'
import { Route as DashboardReglagesAppareilsRouteImport } from './routes/_dashboard/reglages.appareils'
import { Route as DashboardInviterImportRouteImport } from './routes/_dashboard/inviter.import'
import { Route as DashboardCompteNotificationsRouteImport } from './routes/_dashboard/compte.notifications'
import { Route as DashboardArriveeIdRouteImport } from './routes/_dashboard/arrivee.$id'

const SupportRoute = SupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const PosteRoute = PosteRouteImport.update({
  id: '/poste',
  path: '/poste',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteRoute = InviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfidentialiteRoute = ConfidentialiteRouteImport.update({
  id: '/confidentialite',
  path: '/confidentialite',
  getParentRoute: () => rootRouteImport,
} as any)
const ConditionsRoute = ConditionsRouteImport.update({
  id: '/conditions',
  path: '/conditions',
  getParentRoute: () => rootRouteImport,
} as any)
const BorneRoute = BorneRouteImport.update({
  id: '/borne',
  path: '/borne',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const PosteIndexRoute = PosteIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PosteRoute,
} as any)
const BorneIndexRoute = BorneIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BorneRoute,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRoute,
} as any)
const PosteColisRoute = PosteColisRouteImport.update({
  id: '/colis',
  path: '/colis',
  getParentRoute: () => PosteRoute,
} as any)
const PosteCodeRoute = PosteCodeRouteImport.update({
  id: '/code',
  path: '/code',
  getParentRoute: () => PosteRoute,
} as any)
const PosteBorneRoute = PosteBorneRouteImport.update({
  id: '/borne',
  path: '/borne',
  getParentRoute: () => PosteRoute,
} as any)
const PosteAujourdhuiRoute = PosteAujourdhuiRouteImport.update({
  id: '/aujourdhui',
  path: '/aujourdhui',
  getParentRoute: () => PosteRoute,
} as any)
const PosteAttendusRoute = PosteAttendusRouteImport.update({
  id: '/attendus',
  path: '/attendus',
  getParentRoute: () => PosteRoute,
} as any)
const PosteArriveesRoute = PosteArriveesRouteImport.update({
  id: '/arrivees',
  path: '/arrivees',
  getParentRoute: () => PosteRoute,
} as any)
const PosteAppairageRoute = PosteAppairageRouteImport.update({
  id: '/appairage',
  path: '/appairage',
  getParentRoute: () => PosteRoute,
} as any)
const PosteAccesRoute = PosteAccesRouteImport.update({
  id: '/acces',
  path: '/acces',
  getParentRoute: () => PosteRoute,
} as any)
const PassTokenRoute = PassTokenRouteImport.update({
  id: '/pass/$token',
  path: '/pass/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const BorneAppairageRoute = BorneAppairageRouteImport.update({
  id: '/appairage',
  path: '/appairage',
  getParentRoute: () => BorneRoute,
} as any)
const BTokenRoute = BTokenRouteImport.update({
  id: '/b/$token',
  path: '/b/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardVisiteursRoute = DashboardVisiteursRouteImport.update({
  id: '/visiteurs',
  path: '/visiteurs',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSurSiteRoute = DashboardSurSiteRouteImport.update({
  id: '/sur-site',
  path: '/sur-site',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardRepertoireRoute = DashboardRepertoireRouteImport.update({
  id: '/repertoire',
  path: '/repertoire',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardReglagesRoute = DashboardReglagesRouteImport.update({
  id: '/reglages',
  path: '/reglages',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardRapportsRoute = DashboardRapportsRouteImport.update({
  id: '/rapports',
  path: '/rapports',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardOrganizationsRoute = DashboardOrganizationsRouteImport.update({
  id: '/organizations',
  path: '/organizations',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardJournalRoute = DashboardJournalRouteImport.update({
  id: '/journal',
  path: '/journal',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardInvitationsRoute = DashboardInvitationsRouteImport.update({
  id: '/invitations',
  path: '/invitations',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardGestionReservationsRoute =
  DashboardGestionReservationsRouteImport.update({
    id: '/gestion-reservations',
    path: '/gestion-reservations',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardEquipeRoute = DashboardEquipeRouteImport.update({
  id: '/equipe',
  path: '/equipe',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardColisRoute = DashboardColisRouteImport.update({
  id: '/colis',
  path: '/colis',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAttendusRoute = DashboardAttendusRouteImport.update({
  id: '/attendus',
  path: '/attendus',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardArriveesImprevuesRoute =
  DashboardArriveesImprevuesRouteImport.update({
    id: '/arrivees-imprevues',
    path: '/arrivees-imprevues',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardActiviteRoute = DashboardActiviteRouteImport.update({
  id: '/activite',
  path: '/activite',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAccountsRoute = DashboardAccountsRouteImport.update({
  id: '/accounts',
  path: '/accounts',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardReservationsIndexRoute =
  DashboardReservationsIndexRouteImport.update({
    id: '/reservations/',
    path: '/reservations/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardReglagesIndexRoute = DashboardReglagesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardReglagesRoute,
} as any)
const DashboardInviterIndexRoute = DashboardInviterIndexRouteImport.update({
  id: '/inviter/',
  path: '/inviter/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardCompteIndexRoute = DashboardCompteIndexRouteImport.update({
  id: '/compte/',
  path: '/compte/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardReservationsMesReservationsRoute =
  DashboardReservationsMesReservationsRouteImport.update({
    id: '/reservations/mes-reservations',
    path: '/reservations/mes-reservations',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardReservationsAmenityIdRoute =
  DashboardReservationsAmenityIdRouteImport.update({
    id: '/reservations/$amenityId',
    path: '/reservations/$amenityId',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardReglagesValidationsRoute =
  DashboardReglagesValidationsRouteImport.update({
    id: '/validations',
    path: '/validations',
    getParentRoute: () => DashboardReglagesRoute,
  } as any)
const DashboardReglagesUnitesRoute = DashboardReglagesUnitesRouteImport.update({
  id: '/unites',
  path: '/unites',
  getParentRoute: () => DashboardReglagesRoute,
} as any)
const DashboardReglagesReservationsRoute =
  DashboardReglagesReservationsRouteImport.update({
    id: '/reservations',
    path: '/reservations',
    getParentRoute: () => DashboardReglagesRoute,
  } as any)
const DashboardReglagesPortailsRoute =
  DashboardReglagesPortailsRouteImport.update({
    id: '/portails',
    path: '/portails',
    getParentRoute: () => DashboardReglagesRoute,
  } as any)
const DashboardReglagesLegalRoute = DashboardReglagesLegalRouteImport.update({
  id: '/legal',
  path: '/legal',
  getParentRoute: () => DashboardReglagesRoute,
} as any)
const DashboardReglagesInvitationsRoute =
  DashboardReglagesInvitationsRouteImport.update({
    id: '/invitations',
    path: '/invitations',
    getParentRoute: () => DashboardReglagesRoute,
  } as any)
const DashboardReglagesGeneralRoute =
  DashboardReglagesGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => DashboardReglagesRoute,
  } as any)
const DashboardReglagesFormulairesRoute =
  DashboardReglagesFormulairesRouteImport.update({
    id: '/formulaires',
    path: '/formulaires',
    getParentRoute: () => DashboardReglagesRoute,
  } as any)
const DashboardReglagesDonneesRoute =
  DashboardReglagesDonneesRouteImport.update({
    id: '/donnees',
    path: '/donnees',
    getParentRoute: () => DashboardReglagesRoute,
  } as any)
const DashboardReglagesAppareilsRoute =
  DashboardReglagesAppareilsRouteImport.update({
    id: '/appareils',
    path: '/appareils',
    getParentRoute: () => DashboardReglagesRoute,
  } as any)
const DashboardInviterImportRoute = DashboardInviterImportRouteImport.update({
  id: '/inviter/import',
  path: '/inviter/import',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardCompteNotificationsRoute =
  DashboardCompteNotificationsRouteImport.update({
    id: '/compte/notifications',
    path: '/compte/notifications',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardArriveeIdRoute = DashboardArriveeIdRouteImport.update({
  id: '/arrivee/$id',
  path: '/arrivee/$id',
  getParentRoute: () => DashboardRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof DashboardIndexRoute
  '/borne': typeof BorneRouteWithChildren
  '/conditions': typeof ConditionsRoute
  '/confidentialite': typeof ConfidentialiteRoute
  '/invite': typeof InviteRoute
  '/poste': typeof PosteRouteWithChildren
  '/sign-in': typeof SignInRoute
  '/support': typeof SupportRoute
  '/accounts': typeof DashboardAccountsRoute
  '/activite': typeof DashboardActiviteRoute
  '/arrivees-imprevues': typeof DashboardArriveesImprevuesRoute
  '/attendus': typeof DashboardAttendusRoute
  '/colis': typeof DashboardColisRoute
  '/equipe': typeof DashboardEquipeRoute
  '/gestion-reservations': typeof DashboardGestionReservationsRoute
  '/invitations': typeof DashboardInvitationsRoute
  '/journal': typeof DashboardJournalRoute
  '/organizations': typeof DashboardOrganizationsRoute
  '/rapports': typeof DashboardRapportsRoute
  '/reglages': typeof DashboardReglagesRouteWithChildren
  '/repertoire': typeof DashboardRepertoireRoute
  '/sur-site': typeof DashboardSurSiteRoute
  '/visiteurs': typeof DashboardVisiteursRoute
  '/b/$token': typeof BTokenRoute
  '/borne/appairage': typeof BorneAppairageRoute
  '/pass/$token': typeof PassTokenRoute
  '/poste/acces': typeof PosteAccesRoute
  '/poste/appairage': typeof PosteAppairageRoute
  '/poste/arrivees': typeof PosteArriveesRoute
  '/poste/attendus': typeof PosteAttendusRoute
  '/poste/aujourdhui': typeof PosteAujourdhuiRoute
  '/poste/borne': typeof PosteBorneRoute
  '/poste/code': typeof PosteCodeRoute
  '/poste/colis': typeof PosteColisRoute
  '/borne/': typeof BorneIndexRoute
  '/poste/': typeof PosteIndexRoute
  '/arrivee/$id': typeof DashboardArriveeIdRoute
  '/compte/notifications': typeof DashboardCompteNotificationsRoute
  '/inviter/import': typeof DashboardInviterImportRoute
  '/reglages/appareils': typeof DashboardReglagesAppareilsRoute
  '/reglages/donnees': typeof DashboardReglagesDonneesRoute
  '/reglages/formulaires': typeof DashboardReglagesFormulairesRoute
  '/reglages/general': typeof DashboardReglagesGeneralRoute
  '/reglages/invitations': typeof DashboardReglagesInvitationsRoute
  '/reglages/legal': typeof DashboardReglagesLegalRoute
  '/reglages/portails': typeof DashboardReglagesPortailsRoute
  '/reglages/reservations': typeof DashboardReglagesReservationsRoute
  '/reglages/unites': typeof DashboardReglagesUnitesRoute
  '/reglages/validations': typeof DashboardReglagesValidationsRoute
  '/reservations/$amenityId': typeof DashboardReservationsAmenityIdRoute
  '/reservations/mes-reservations': typeof DashboardReservationsMesReservationsRoute
  '/compte/': typeof DashboardCompteIndexRoute
  '/inviter/': typeof DashboardInviterIndexRoute
  '/reglages/': typeof DashboardReglagesIndexRoute
  '/reservations/': typeof DashboardReservationsIndexRoute
}
export interface FileRoutesByTo {
  '/conditions': typeof ConditionsRoute
  '/confidentialite': typeof ConfidentialiteRoute
  '/invite': typeof InviteRoute
  '/sign-in': typeof SignInRoute
  '/support': typeof SupportRoute
  '/accounts': typeof DashboardAccountsRoute
  '/activite': typeof DashboardActiviteRoute
  '/arrivees-imprevues': typeof DashboardArriveesImprevuesRoute
  '/attendus': typeof DashboardAttendusRoute
  '/colis': typeof DashboardColisRoute
  '/equipe': typeof DashboardEquipeRoute
  '/gestion-reservations': typeof DashboardGestionReservationsRoute
  '/invitations': typeof DashboardInvitationsRoute
  '/journal': typeof DashboardJournalRoute
  '/organizations': typeof DashboardOrganizationsRoute
  '/rapports': typeof DashboardRapportsRoute
  '/repertoire': typeof DashboardRepertoireRoute
  '/sur-site': typeof DashboardSurSiteRoute
  '/visiteurs': typeof DashboardVisiteursRoute
  '/b/$token': typeof BTokenRoute
  '/borne/appairage': typeof BorneAppairageRoute
  '/pass/$token': typeof PassTokenRoute
  '/poste/acces': typeof PosteAccesRoute
  '/poste/appairage': typeof PosteAppairageRoute
  '/poste/arrivees': typeof PosteArriveesRoute
  '/poste/attendus': typeof PosteAttendusRoute
  '/poste/aujourdhui': typeof PosteAujourdhuiRoute
  '/poste/borne': typeof PosteBorneRoute
  '/poste/code': typeof PosteCodeRoute
  '/poste/colis': typeof PosteColisRoute
  '/': typeof DashboardIndexRoute
  '/borne': typeof BorneIndexRoute
  '/poste': typeof PosteIndexRoute
  '/arrivee/$id': typeof DashboardArriveeIdRoute
  '/compte/notifications': typeof DashboardCompteNotificationsRoute
  '/inviter/import': typeof DashboardInviterImportRoute
  '/reglages/appareils': typeof DashboardReglagesAppareilsRoute
  '/reglages/donnees': typeof DashboardReglagesDonneesRoute
  '/reglages/formulaires': typeof DashboardReglagesFormulairesRoute
  '/reglages/general': typeof DashboardReglagesGeneralRoute
  '/reglages/invitations': typeof DashboardReglagesInvitationsRoute
  '/reglages/legal': typeof DashboardReglagesLegalRoute
  '/reglages/portails': typeof DashboardReglagesPortailsRoute
  '/reglages/reservations': typeof DashboardReglagesReservationsRoute
  '/reglages/unites': typeof DashboardReglagesUnitesRoute
  '/reglages/validations': typeof DashboardReglagesValidationsRoute
  '/reservations/$amenityId': typeof DashboardReservationsAmenityIdRoute
  '/reservations/mes-reservations': typeof DashboardReservationsMesReservationsRoute
  '/compte': typeof DashboardCompteIndexRoute
  '/inviter': typeof DashboardInviterIndexRoute
  '/reglages': typeof DashboardReglagesIndexRoute
  '/reservations': typeof DashboardReservationsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_dashboard': typeof DashboardRouteWithChildren
  '/borne': typeof BorneRouteWithChildren
  '/conditions': typeof ConditionsRoute
  '/confidentialite': typeof ConfidentialiteRoute
  '/invite': typeof InviteRoute
  '/poste': typeof PosteRouteWithChildren
  '/sign-in': typeof SignInRoute
  '/support': typeof SupportRoute
  '/_dashboard/accounts': typeof DashboardAccountsRoute
  '/_dashboard/activite': typeof DashboardActiviteRoute
  '/_dashboard/arrivees-imprevues': typeof DashboardArriveesImprevuesRoute
  '/_dashboard/attendus': typeof DashboardAttendusRoute
  '/_dashboard/colis': typeof DashboardColisRoute
  '/_dashboard/equipe': typeof DashboardEquipeRoute
  '/_dashboard/gestion-reservations': typeof DashboardGestionReservationsRoute
  '/_dashboard/invitations': typeof DashboardInvitationsRoute
  '/_dashboard/journal': typeof DashboardJournalRoute
  '/_dashboard/organizations': typeof DashboardOrganizationsRoute
  '/_dashboard/rapports': typeof DashboardRapportsRoute
  '/_dashboard/reglages': typeof DashboardReglagesRouteWithChildren
  '/_dashboard/repertoire': typeof DashboardRepertoireRoute
  '/_dashboard/sur-site': typeof DashboardSurSiteRoute
  '/_dashboard/visiteurs': typeof DashboardVisiteursRoute
  '/b/$token': typeof BTokenRoute
  '/borne/appairage': typeof BorneAppairageRoute
  '/pass/$token': typeof PassTokenRoute
  '/poste/acces': typeof PosteAccesRoute
  '/poste/appairage': typeof PosteAppairageRoute
  '/poste/arrivees': typeof PosteArriveesRoute
  '/poste/attendus': typeof PosteAttendusRoute
  '/poste/aujourdhui': typeof PosteAujourdhuiRoute
  '/poste/borne': typeof PosteBorneRoute
  '/poste/code': typeof PosteCodeRoute
  '/poste/colis': typeof PosteColisRoute
  '/_dashboard/': typeof DashboardIndexRoute
  '/borne/': typeof BorneIndexRoute
  '/poste/': typeof PosteIndexRoute
  '/_dashboard/arrivee/$id': typeof DashboardArriveeIdRoute
  '/_dashboard/compte/notifications': typeof DashboardCompteNotificationsRoute
  '/_dashboard/inviter/import': typeof DashboardInviterImportRoute
  '/_dashboard/reglages/appareils': typeof DashboardReglagesAppareilsRoute
  '/_dashboard/reglages/donnees': typeof DashboardReglagesDonneesRoute
  '/_dashboard/reglages/formulaires': typeof DashboardReglagesFormulairesRoute
  '/_dashboard/reglages/general': typeof DashboardReglagesGeneralRoute
  '/_dashboard/reglages/invitations': typeof DashboardReglagesInvitationsRoute
  '/_dashboard/reglages/legal': typeof DashboardReglagesLegalRoute
  '/_dashboard/reglages/portails': typeof DashboardReglagesPortailsRoute
  '/_dashboard/reglages/reservations': typeof DashboardReglagesReservationsRoute
  '/_dashboard/reglages/unites': typeof DashboardReglagesUnitesRoute
  '/_dashboard/reglages/validations': typeof DashboardReglagesValidationsRoute
  '/_dashboard/reservations/$amenityId': typeof DashboardReservationsAmenityIdRoute
  '/_dashboard/reservations/mes-reservations': typeof DashboardReservationsMesReservationsRoute
  '/_dashboard/compte/': typeof DashboardCompteIndexRoute
  '/_dashboard/inviter/': typeof DashboardInviterIndexRoute
  '/_dashboard/reglages/': typeof DashboardReglagesIndexRoute
  '/_dashboard/reservations/': typeof DashboardReservationsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/borne'
    | '/conditions'
    | '/confidentialite'
    | '/invite'
    | '/poste'
    | '/sign-in'
    | '/support'
    | '/accounts'
    | '/activite'
    | '/arrivees-imprevues'
    | '/attendus'
    | '/colis'
    | '/equipe'
    | '/gestion-reservations'
    | '/invitations'
    | '/journal'
    | '/organizations'
    | '/rapports'
    | '/reglages'
    | '/repertoire'
    | '/sur-site'
    | '/visiteurs'
    | '/b/$token'
    | '/borne/appairage'
    | '/pass/$token'
    | '/poste/acces'
    | '/poste/appairage'
    | '/poste/arrivees'
    | '/poste/attendus'
    | '/poste/aujourdhui'
    | '/poste/borne'
    | '/poste/code'
    | '/poste/colis'
    | '/borne/'
    | '/poste/'
    | '/arrivee/$id'
    | '/compte/notifications'
    | '/inviter/import'
    | '/reglages/appareils'
    | '/reglages/donnees'
    | '/reglages/formulaires'
    | '/reglages/general'
    | '/reglages/invitations'
    | '/reglages/legal'
    | '/reglages/portails'
    | '/reglages/reservations'
    | '/reglages/unites'
    | '/reglages/validations'
    | '/reservations/$amenityId'
    | '/reservations/mes-reservations'
    | '/compte/'
    | '/inviter/'
    | '/reglages/'
    | '/reservations/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/conditions'
    | '/confidentialite'
    | '/invite'
    | '/sign-in'
    | '/support'
    | '/accounts'
    | '/activite'
    | '/arrivees-imprevues'
    | '/attendus'
    | '/colis'
    | '/equipe'
    | '/gestion-reservations'
    | '/invitations'
    | '/journal'
    | '/organizations'
    | '/rapports'
    | '/repertoire'
    | '/sur-site'
    | '/visiteurs'
    | '/b/$token'
    | '/borne/appairage'
    | '/pass/$token'
    | '/poste/acces'
    | '/poste/appairage'
    | '/poste/arrivees'
    | '/poste/attendus'
    | '/poste/aujourdhui'
    | '/poste/borne'
    | '/poste/code'
    | '/poste/colis'
    | '/'
    | '/borne'
    | '/poste'
    | '/arrivee/$id'
    | '/compte/notifications'
    | '/inviter/import'
    | '/reglages/appareils'
    | '/reglages/donnees'
    | '/reglages/formulaires'
    | '/reglages/general'
    | '/reglages/invitations'
    | '/reglages/legal'
    | '/reglages/portails'
    | '/reglages/reservations'
    | '/reglages/unites'
    | '/reglages/validations'
    | '/reservations/$amenityId'
    | '/reservations/mes-reservations'
    | '/compte'
    | '/inviter'
    | '/reglages'
    | '/reservations'
  id:
    | '__root__'
    | '/_dashboard'
    | '/borne'
    | '/conditions'
    | '/confidentialite'
    | '/invite'
    | '/poste'
    | '/sign-in'
    | '/support'
    | '/_dashboard/accounts'
    | '/_dashboard/activite'
    | '/_dashboard/arrivees-imprevues'
    | '/_dashboard/attendus'
    | '/_dashboard/colis'
    | '/_dashboard/equipe'
    | '/_dashboard/gestion-reservations'
    | '/_dashboard/invitations'
    | '/_dashboard/journal'
    | '/_dashboard/organizations'
    | '/_dashboard/rapports'
    | '/_dashboard/reglages'
    | '/_dashboard/repertoire'
    | '/_dashboard/sur-site'
    | '/_dashboard/visiteurs'
    | '/b/$token'
    | '/borne/appairage'
    | '/pass/$token'
    | '/poste/acces'
    | '/poste/appairage'
    | '/poste/arrivees'
    | '/poste/attendus'
    | '/poste/aujourdhui'
    | '/poste/borne'
    | '/poste/code'
    | '/poste/colis'
    | '/_dashboard/'
    | '/borne/'
    | '/poste/'
    | '/_dashboard/arrivee/$id'
    | '/_dashboard/compte/notifications'
    | '/_dashboard/inviter/import'
    | '/_dashboard/reglages/appareils'
    | '/_dashboard/reglages/donnees'
    | '/_dashboard/reglages/formulaires'
    | '/_dashboard/reglages/general'
    | '/_dashboard/reglages/invitations'
    | '/_dashboard/reglages/legal'
    | '/_dashboard/reglages/portails'
    | '/_dashboard/reglages/reservations'
    | '/_dashboard/reglages/unites'
    | '/_dashboard/reglages/validations'
    | '/_dashboard/reservations/$amenityId'
    | '/_dashboard/reservations/mes-reservations'
    | '/_dashboard/compte/'
    | '/_dashboard/inviter/'
    | '/_dashboard/reglages/'
    | '/_dashboard/reservations/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  DashboardRoute: typeof DashboardRouteWithChildren
  BorneRoute: typeof BorneRouteWithChildren
  ConditionsRoute: typeof ConditionsRoute
  ConfidentialiteRoute: typeof ConfidentialiteRoute
  InviteRoute: typeof InviteRoute
  PosteRoute: typeof PosteRouteWithChildren
  SignInRoute: typeof SignInRoute
  SupportRoute: typeof SupportRoute
  BTokenRoute: typeof BTokenRoute
  PassTokenRoute: typeof PassTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/support': {
      id: '/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof SupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/poste': {
      id: '/poste'
      path: '/poste'
      fullPath: '/poste'
      preLoaderRoute: typeof PosteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite': {
      id: '/invite'
      path: '/invite'
      fullPath: '/invite'
      preLoaderRoute: typeof InviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/confidentialite': {
      id: '/confidentialite'
      path: '/confidentialite'
      fullPath: '/confidentialite'
      preLoaderRoute: typeof ConfidentialiteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/conditions': {
      id: '/conditions'
      path: '/conditions'
      fullPath: '/conditions'
      preLoaderRoute: typeof ConditionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/borne': {
      id: '/borne'
      path: '/borne'
      fullPath: '/borne'
      preLoaderRoute: typeof BorneRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard': {
      id: '/_dashboard'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/poste/': {
      id: '/poste/'
      path: '/'
      fullPath: '/poste/'
      preLoaderRoute: typeof PosteIndexRouteImport
      parentRoute: typeof PosteRoute
    }
    '/borne/': {
      id: '/borne/'
      path: '/'
      fullPath: '/borne/'
      preLoaderRoute: typeof BorneIndexRouteImport
      parentRoute: typeof BorneRoute
    }
    '/_dashboard/': {
      id: '/_dashboard/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/poste/colis': {
      id: '/poste/colis'
      path: '/colis'
      fullPath: '/poste/colis'
      preLoaderRoute: typeof PosteColisRouteImport
      parentRoute: typeof PosteRoute
    }
    '/poste/code': {
      id: '/poste/code'
      path: '/code'
      fullPath: '/poste/code'
      preLoaderRoute: typeof PosteCodeRouteImport
      parentRoute: typeof PosteRoute
    }
    '/poste/borne': {
      id: '/poste/borne'
      path: '/borne'
      fullPath: '/poste/borne'
      preLoaderRoute: typeof PosteBorneRouteImport
      parentRoute: typeof PosteRoute
    }
    '/poste/aujourdhui': {
      id: '/poste/aujourdhui'
      path: '/aujourdhui'
      fullPath: '/poste/aujourdhui'
      preLoaderRoute: typeof PosteAujourdhuiRouteImport
      parentRoute: typeof PosteRoute
    }
    '/poste/attendus': {
      id: '/poste/attendus'
      path: '/attendus'
      fullPath: '/poste/attendus'
      preLoaderRoute: typeof PosteAttendusRouteImport
      parentRoute: typeof PosteRoute
    }
    '/poste/arrivees': {
      id: '/poste/arrivees'
      path: '/arrivees'
      fullPath: '/poste/arrivees'
      preLoaderRoute: typeof PosteArriveesRouteImport
      parentRoute: typeof PosteRoute
    }
    '/poste/appairage': {
      id: '/poste/appairage'
      path: '/appairage'
      fullPath: '/poste/appairage'
      preLoaderRoute: typeof PosteAppairageRouteImport
      parentRoute: typeof PosteRoute
    }
    '/poste/acces': {
      id: '/poste/acces'
      path: '/acces'
      fullPath: '/poste/acces'
      preLoaderRoute: typeof PosteAccesRouteImport
      parentRoute: typeof PosteRoute
    }
    '/pass/$token': {
      id: '/pass/$token'
      path: '/pass/$token'
      fullPath: '/pass/$token'
      preLoaderRoute: typeof PassTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/borne/appairage': {
      id: '/borne/appairage'
      path: '/appairage'
      fullPath: '/borne/appairage'
      preLoaderRoute: typeof BorneAppairageRouteImport
      parentRoute: typeof BorneRoute
    }
    '/b/$token': {
      id: '/b/$token'
      path: '/b/$token'
      fullPath: '/b/$token'
      preLoaderRoute: typeof BTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/visiteurs': {
      id: '/_dashboard/visiteurs'
      path: '/visiteurs'
      fullPath: '/visiteurs'
      preLoaderRoute: typeof DashboardVisiteursRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/sur-site': {
      id: '/_dashboard/sur-site'
      path: '/sur-site'
      fullPath: '/sur-site'
      preLoaderRoute: typeof DashboardSurSiteRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/repertoire': {
      id: '/_dashboard/repertoire'
      path: '/repertoire'
      fullPath: '/repertoire'
      preLoaderRoute: typeof DashboardRepertoireRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/reglages': {
      id: '/_dashboard/reglages'
      path: '/reglages'
      fullPath: '/reglages'
      preLoaderRoute: typeof DashboardReglagesRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/rapports': {
      id: '/_dashboard/rapports'
      path: '/rapports'
      fullPath: '/rapports'
      preLoaderRoute: typeof DashboardRapportsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/organizations': {
      id: '/_dashboard/organizations'
      path: '/organizations'
      fullPath: '/organizations'
      preLoaderRoute: typeof DashboardOrganizationsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/journal': {
      id: '/_dashboard/journal'
      path: '/journal'
      fullPath: '/journal'
      preLoaderRoute: typeof DashboardJournalRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/invitations': {
      id: '/_dashboard/invitations'
      path: '/invitations'
      fullPath: '/invitations'
      preLoaderRoute: typeof DashboardInvitationsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/gestion-reservations': {
      id: '/_dashboard/gestion-reservations'
      path: '/gestion-reservations'
      fullPath: '/gestion-reservations'
      preLoaderRoute: typeof DashboardGestionReservationsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/equipe': {
      id: '/_dashboard/equipe'
      path: '/equipe'
      fullPath: '/equipe'
      preLoaderRoute: typeof DashboardEquipeRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/colis': {
      id: '/_dashboard/colis'
      path: '/colis'
      fullPath: '/colis'
      preLoaderRoute: typeof DashboardColisRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/attendus': {
      id: '/_dashboard/attendus'
      path: '/attendus'
      fullPath: '/attendus'
      preLoaderRoute: typeof DashboardAttendusRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/arrivees-imprevues': {
      id: '/_dashboard/arrivees-imprevues'
      path: '/arrivees-imprevues'
      fullPath: '/arrivees-imprevues'
      preLoaderRoute: typeof DashboardArriveesImprevuesRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/activite': {
      id: '/_dashboard/activite'
      path: '/activite'
      fullPath: '/activite'
      preLoaderRoute: typeof DashboardActiviteRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/accounts': {
      id: '/_dashboard/accounts'
      path: '/accounts'
      fullPath: '/accounts'
      preLoaderRoute: typeof DashboardAccountsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/reservations/': {
      id: '/_dashboard/reservations/'
      path: '/reservations'
      fullPath: '/reservations/'
      preLoaderRoute: typeof DashboardReservationsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/reglages/': {
      id: '/_dashboard/reglages/'
      path: '/'
      fullPath: '/reglages/'
      preLoaderRoute: typeof DashboardReglagesIndexRouteImport
      parentRoute: typeof DashboardReglagesRoute
    }
    '/_dashboard/inviter/': {
      id: '/_dashboard/inviter/'
      path: '/inviter'
      fullPath: '/inviter/'
      preLoaderRoute: typeof DashboardInviterIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/compte/': {
      id: '/_dashboard/compte/'
      path: '/compte'
      fullPath: '/compte/'
      preLoaderRoute: typeof DashboardCompteIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/reservations/mes-reservations': {
      id: '/_dashboard/reservations/mes-reservations'
      path: '/reservations/mes-reservations'
      fullPath: '/reservations/mes-reservations'
      preLoaderRoute: typeof DashboardReservationsMesReservationsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/reservations/$amenityId': {
      id: '/_dashboard/reservations/$amenityId'
      path: '/reservations/$amenityId'
      fullPath: '/reservations/$amenityId'
      preLoaderRoute: typeof DashboardReservationsAmenityIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/reglages/validations': {
      id: '/_dashboard/reglages/validations'
      path: '/validations'
      fullPath: '/reglages/validations'
      preLoaderRoute: typeof DashboardReglagesValidationsRouteImport
      parentRoute: typeof DashboardReglagesRoute
    }
    '/_dashboard/reglages/unites': {
      id: '/_dashboard/reglages/unites'
      path: '/unites'
      fullPath: '/reglages/unites'
      preLoaderRoute: typeof DashboardReglagesUnitesRouteImport
      parentRoute: typeof DashboardReglagesRoute
    }
    '/_dashboard/reglages/reservations': {
      id: '/_dashboard/reglages/reservations'
      path: '/reservations'
      fullPath: '/reglages/reservations'
      preLoaderRoute: typeof DashboardReglagesReservationsRouteImport
      parentRoute: typeof DashboardReglagesRoute
    }
    '/_dashboard/reglages/portails': {
      id: '/_dashboard/reglages/portails'
      path: '/portails'
      fullPath: '/reglages/portails'
      preLoaderRoute: typeof DashboardReglagesPortailsRouteImport
      parentRoute: typeof DashboardReglagesRoute
    }
    '/_dashboard/reglages/legal': {
      id: '/_dashboard/reglages/legal'
      path: '/legal'
      fullPath: '/reglages/legal'
      preLoaderRoute: typeof DashboardReglagesLegalRouteImport
      parentRoute: typeof DashboardReglagesRoute
    }
    '/_dashboard/reglages/invitations': {
      id: '/_dashboard/reglages/invitations'
      path: '/invitations'
      fullPath: '/reglages/invitations'
      preLoaderRoute: typeof DashboardReglagesInvitationsRouteImport
      parentRoute: typeof DashboardReglagesRoute
    }
    '/_dashboard/reglages/general': {
      id: '/_dashboard/reglages/general'
      path: '/general'
      fullPath: '/reglages/general'
      preLoaderRoute: typeof DashboardReglagesGeneralRouteImport
      parentRoute: typeof DashboardReglagesRoute
    }
    '/_dashboard/reglages/formulaires': {
      id: '/_dashboard/reglages/formulaires'
      path: '/formulaires'
      fullPath: '/reglages/formulaires'
      preLoaderRoute: typeof DashboardReglagesFormulairesRouteImport
      parentRoute: typeof DashboardReglagesRoute
    }
    '/_dashboard/reglages/donnees': {
      id: '/_dashboard/reglages/donnees'
      path: '/donnees'
      fullPath: '/reglages/donnees'
      preLoaderRoute: typeof DashboardReglagesDonneesRouteImport
      parentRoute: typeof DashboardReglagesRoute
    }
    '/_dashboard/reglages/appareils': {
      id: '/_dashboard/reglages/appareils'
      path: '/appareils'
      fullPath: '/reglages/appareils'
      preLoaderRoute: typeof DashboardReglagesAppareilsRouteImport
      parentRoute: typeof DashboardReglagesRoute
    }
    '/_dashboard/inviter/import': {
      id: '/_dashboard/inviter/import'
      path: '/inviter/import'
      fullPath: '/inviter/import'
      preLoaderRoute: typeof DashboardInviterImportRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/compte/notifications': {
      id: '/_dashboard/compte/notifications'
      path: '/compte/notifications'
      fullPath: '/compte/notifications'
      preLoaderRoute: typeof DashboardCompteNotificationsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/arrivee/$id': {
      id: '/_dashboard/arrivee/$id'
      path: '/arrivee/$id'
      fullPath: '/arrivee/$id'
      preLoaderRoute: typeof DashboardArriveeIdRouteImport
      parentRoute: typeof DashboardRoute
    }
  }
}

interface DashboardReglagesRouteChildren {
  DashboardReglagesAppareilsRoute: typeof DashboardReglagesAppareilsRoute
  DashboardReglagesDonneesRoute: typeof DashboardReglagesDonneesRoute
  DashboardReglagesFormulairesRoute: typeof DashboardReglagesFormulairesRoute
  DashboardReglagesGeneralRoute: typeof DashboardReglagesGeneralRoute
  DashboardReglagesInvitationsRoute: typeof DashboardReglagesInvitationsRoute
  DashboardReglagesLegalRoute: typeof DashboardReglagesLegalRoute
  DashboardReglagesPortailsRoute: typeof DashboardReglagesPortailsRoute
  DashboardReglagesReservationsRoute: typeof DashboardReglagesReservationsRoute
  DashboardReglagesUnitesRoute: typeof DashboardReglagesUnitesRoute
  DashboardReglagesValidationsRoute: typeof DashboardReglagesValidationsRoute
  DashboardReglagesIndexRoute: typeof DashboardReglagesIndexRoute
}

const DashboardReglagesRouteChildren: DashboardReglagesRouteChildren = {
  DashboardReglagesAppareilsRoute: DashboardReglagesAppareilsRoute,
  DashboardReglagesDonneesRoute: DashboardReglagesDonneesRoute,
  DashboardReglagesFormulairesRoute: DashboardReglagesFormulairesRoute,
  DashboardReglagesGeneralRoute: DashboardReglagesGeneralRoute,
  DashboardReglagesInvitationsRoute: DashboardReglagesInvitationsRoute,
  DashboardReglagesLegalRoute: DashboardReglagesLegalRoute,
  DashboardReglagesPortailsRoute: DashboardReglagesPortailsRoute,
  DashboardReglagesReservationsRoute: DashboardReglagesReservationsRoute,
  DashboardReglagesUnitesRoute: DashboardReglagesUnitesRoute,
  DashboardReglagesValidationsRoute: DashboardReglagesValidationsRoute,
  DashboardReglagesIndexRoute: DashboardReglagesIndexRoute,
}

const DashboardReglagesRouteWithChildren =
  DashboardReglagesRoute._addFileChildren(DashboardReglagesRouteChildren)

interface DashboardRouteChildren {
  DashboardAccountsRoute: typeof DashboardAccountsRoute
  DashboardActiviteRoute: typeof DashboardActiviteRoute
  DashboardArriveesImprevuesRoute: typeof DashboardArriveesImprevuesRoute
  DashboardAttendusRoute: typeof DashboardAttendusRoute
  DashboardColisRoute: typeof DashboardColisRoute
  DashboardEquipeRoute: typeof DashboardEquipeRoute
  DashboardGestionReservationsRoute: typeof DashboardGestionReservationsRoute
  DashboardInvitationsRoute: typeof DashboardInvitationsRoute
  DashboardJournalRoute: typeof DashboardJournalRoute
  DashboardOrganizationsRoute: typeof DashboardOrganizationsRoute
  DashboardRapportsRoute: typeof DashboardRapportsRoute
  DashboardReglagesRoute: typeof DashboardReglagesRouteWithChildren
  DashboardRepertoireRoute: typeof DashboardRepertoireRoute
  DashboardSurSiteRoute: typeof DashboardSurSiteRoute
  DashboardVisiteursRoute: typeof DashboardVisiteursRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardArriveeIdRoute: typeof DashboardArriveeIdRoute
  DashboardCompteNotificationsRoute: typeof DashboardCompteNotificationsRoute
  DashboardInviterImportRoute: typeof DashboardInviterImportRoute
  DashboardReservationsAmenityIdRoute: typeof DashboardReservationsAmenityIdRoute
  DashboardReservationsMesReservationsRoute: typeof DashboardReservationsMesReservationsRoute
  DashboardCompteIndexRoute: typeof DashboardCompteIndexRoute
  DashboardInviterIndexRoute: typeof DashboardInviterIndexRoute
  DashboardReservationsIndexRoute: typeof DashboardReservationsIndexRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardAccountsRoute: DashboardAccountsRoute,
  DashboardActiviteRoute: DashboardActiviteRoute,
  DashboardArriveesImprevuesRoute: DashboardArriveesImprevuesRoute,
  DashboardAttendusRoute: DashboardAttendusRoute,
  DashboardColisRoute: DashboardColisRoute,
  DashboardEquipeRoute: DashboardEquipeRoute,
  DashboardGestionReservationsRoute: DashboardGestionReservationsRoute,
  DashboardInvitationsRoute: DashboardInvitationsRoute,
  DashboardJournalRoute: DashboardJournalRoute,
  DashboardOrganizationsRoute: DashboardOrganizationsRoute,
  DashboardRapportsRoute: DashboardRapportsRoute,
  DashboardReglagesRoute: DashboardReglagesRouteWithChildren,
  DashboardRepertoireRoute: DashboardRepertoireRoute,
  DashboardSurSiteRoute: DashboardSurSiteRoute,
  DashboardVisiteursRoute: DashboardVisiteursRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardArriveeIdRoute: DashboardArriveeIdRoute,
  DashboardCompteNotificationsRoute: DashboardCompteNotificationsRoute,
  DashboardInviterImportRoute: DashboardInviterImportRoute,
  DashboardReservationsAmenityIdRoute: DashboardReservationsAmenityIdRoute,
  DashboardReservationsMesReservationsRoute:
    DashboardReservationsMesReservationsRoute,
  DashboardCompteIndexRoute: DashboardCompteIndexRoute,
  DashboardInviterIndexRoute: DashboardInviterIndexRoute,
  DashboardReservationsIndexRoute: DashboardReservationsIndexRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

interface BorneRouteChildren {
  BorneAppairageRoute: typeof BorneAppairageRoute
  BorneIndexRoute: typeof BorneIndexRoute
}

const BorneRouteChildren: BorneRouteChildren = {
  BorneAppairageRoute: BorneAppairageRoute,
  BorneIndexRoute: BorneIndexRoute,
}

const BorneRouteWithChildren = BorneRoute._addFileChildren(BorneRouteChildren)

interface PosteRouteChildren {
  PosteAccesRoute: typeof PosteAccesRoute
  PosteAppairageRoute: typeof PosteAppairageRoute
  PosteArriveesRoute: typeof PosteArriveesRoute
  PosteAttendusRoute: typeof PosteAttendusRoute
  PosteAujourdhuiRoute: typeof PosteAujourdhuiRoute
  PosteBorneRoute: typeof PosteBorneRoute
  PosteCodeRoute: typeof PosteCodeRoute
  PosteColisRoute: typeof PosteColisRoute
  PosteIndexRoute: typeof PosteIndexRoute
}

const PosteRouteChildren: PosteRouteChildren = {
  PosteAccesRoute: PosteAccesRoute,
  PosteAppairageRoute: PosteAppairageRoute,
  PosteArriveesRoute: PosteArriveesRoute,
  PosteAttendusRoute: PosteAttendusRoute,
  PosteAujourdhuiRoute: PosteAujourdhuiRoute,
  PosteBorneRoute: PosteBorneRoute,
  PosteCodeRoute: PosteCodeRoute,
  PosteColisRoute: PosteColisRoute,
  PosteIndexRoute: PosteIndexRoute,
}

const PosteRouteWithChildren = PosteRoute._addFileChildren(PosteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  DashboardRoute: DashboardRouteWithChildren,
  BorneRoute: BorneRouteWithChildren,
  ConditionsRoute: ConditionsRoute,
  ConfidentialiteRoute: ConfidentialiteRoute,
  InviteRoute: InviteRoute,
  PosteRoute: PosteRouteWithChildren,
  SignInRoute: SignInRoute,
  SupportRoute: SupportRoute,
  BTokenRoute: BTokenRoute,
  PassTokenRoute: PassTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
